<div class="public-page">

  <!-- =====================================================
       LADEN
       ===================================================== -->
  <div class="zustand" *ngIf="isLoading">

    <div class="spinner"></div>

    <p>
      Messstelle wird geladen …
    </p>

  </div>


  <!-- =====================================================
       FEHLER
       ===================================================== -->
  <div class="zustand fehler" *ngIf="!isLoading && loadError">

    <div class="fehler-icon">
      !
    </div>

    <h1>
      Messstelle nicht verfügbar
    </h1>

    <p>
      {{ loadError }}
    </p>

    <button type="button" class="button sekundar" (click)="neuLaden()">

      Erneut versuchen

    </button>

  </div>


  <!-- =====================================================
       INHALT
       ===================================================== -->
  <ng-container *ngIf="!isLoading && !loadError && messstelle as m">

    <header class="kopf">

      <div>

        <p class="eyebrow">
          Containuel · Messstelle
        </p>

        <p class="header-label">
          {{ kennzeichnungLabel }}
        </p>

        <h1>
          {{ kennzeichnungWert }}
        </h1>

        <p class="untertitel">
          {{ langtextWert }}
        </p>

        <p class="projektzeile">
          {{ projektAnzeige }}
        </p>

      </div>

      <button *ngIf="m.hasRegularAccess" type="button" class="button primaer" (click)="oeffneRegulaer()">

        {{ m.canEdit ? 'Messstelle bearbeiten' : 'Reguläre Ansicht öffnen' }}

      </button>

    </header>


    <!-- ===================================================
         QR-RECHTEHINWEIS
         =================================================== -->
    <section class="zugriff-box" [class.regulaer]="m.hasRegularAccess">

      <div class="zugriff-icon">
        {{ m.hasRegularAccess ? '✓' : '🔒' }}
      </div>

      <div>

        <strong *ngIf="!m.hasRegularAccess">
          Nur-Lese-Zugriff über QR-Code
        </strong>

        <strong *ngIf="m.hasRegularAccess && m.canEdit">
          Regulärer Zugriff erkannt
        </strong>

        <strong *ngIf="m.hasRegularAccess && !m.canEdit">
          Regulärer Lesezugriff erkannt
        </strong>


        <p *ngIf="!m.hasRegularAccess">
          Diese Messstelle kann über den QR-Code angesehen werden.
          Änderungen sind über diesen Zugang nicht möglich.
        </p>

        <p *ngIf="m.hasRegularAccess && m.canEdit">
          Du bist angemeldet und darfst diese Messstelle regulär bearbeiten.
          Der QR-Zugang selbst bleibt trotzdem nur lesend.
        </p>

        <p *ngIf="m.hasRegularAccess && !m.canEdit">
          Du bist angemeldet und hast regulären Zugriff, aber keine
          Bearbeitungsrechte.
        </p>

      </div>

    </section>


    <!-- ===================================================
         ZUORDNUNG
         =================================================== -->
    <section class="karte">

      <h2>
        Zuordnung
      </h2>

      <div class="info-grid">

        <div class="info">
          <span class="label">Projekt</span>
          <span class="wert">
            {{ m.projektName || '–' }}
          </span>
        </div>

        <div class="info">
          <span class="label">Projektnummer</span>
          <span class="wert">
            {{ m.projektNummer || '–' }}
          </span>
        </div>

        <div class="info">
          <span class="label">Kunde</span>
          <span class="wert">
            {{ m.customerName || '–' }}
          </span>
        </div>

        <div class="info">
          <span class="label">Inbetriebnahme</span>
          <span class="wert">
            {{ m.messstellenListeName }}
          </span>
        </div>

        <div class="info">
          <span class="label">Anlagenteil</span>
          <span class="wert">
            {{ m.anlagenteilName || '–' }}
          </span>
        </div>

        <div class="info">
          <span class="label">Kategorie</span>
          <span class="wert">
            {{ m.kategorieName || '–' }}
          </span>
        </div>

      </div>

    </section>


    <!-- ===================================================
     MESSSTELLENDATEN
     =================================================== -->
    <section class="karte">

      <div class="section-kopf messdaten-kopf">

        <h2>
          Messstellendaten
        </h2>

        <span class="daten-anzahl" *ngIf="alleDaten.length > 0">

          {{ alleDaten.length }} Felder

        </span>

      </div>


      <!-- Wichtige Daten zuerst -->
      <div class="daten-grid" *ngIf="hauptDaten.length > 0">

        <div class="daten-zeile" *ngFor="let eintrag of hauptDaten">

          <span class="label">
            {{ eintrag.label }}
          </span>

          <span class="wert">
            {{ eintrag.value }}
          </span>

        </div>

      </div>


      <!-- Weitere Daten aufklappen -->
      <button *ngIf="zusatzDaten.length > 0" type="button" class="zusatz-toggle" (click)="toggleZusatzinfos()">

        <span class="toggle-symbol">
          {{ zusatzinfosOffen ? '⌃' : '⌄' }}
        </span>

        <span>
          {{
          zusatzinfosOffen
          ? 'Zusatzinfos ausblenden'
          : 'Alle Zusatzinfos anzeigen (' + zusatzDaten.length + ')'
          }}
        </span>

      </button>


      <!-- Alle weiteren Daten -->
      <div class="zusatz-daten" *ngIf="zusatzinfosOffen && zusatzDaten.length > 0">

        <div class="daten-grid">

          <div class="daten-zeile" *ngFor="let eintrag of zusatzDaten">

            <span class="label">
              {{ eintrag.label }}
            </span>

            <span class="wert">
              {{ eintrag.value }}
            </span>

          </div>

        </div>

      </div>


      <p class="leer" *ngIf="alleDaten.length === 0">

        Keine technischen Daten hinterlegt.

      </p>

    </section>


    <!-- ===================================================
         PRÜFSTATUS
         =================================================== -->
    <section class="karte">

      <div class="section-kopf">

        <h2>
          Prüfstatus
        </h2>

        <span class="prozent">
          {{ fortschrittProzent }} %
        </span>

      </div>


      <div class="fortschritt">

        <div class="fortschritt-wert" [style.width.%]="fortschrittProzent">
        </div>

      </div>


      <div class="status-grid">

        <div class="status-box">

          <span class="label">
            Fortschritt
          </span>

          <strong>
            {{ pruefpunkteErledigt }} / {{ pruefpunkteGesamt }}
          </strong>

        </div>

        <div class="status-box">

          <span class="label">
            Prüfergebnis
          </span>

          <strong>
            {{ pruefergebnisText(m.pruefergebnis) }}
          </strong>

        </div>

        <div class="status-box">

          <span class="label">
            Signalstatus
          </span>

          <strong>
            {{ signalStatusText(m.signalStatus) }}
          </strong>

        </div>

      </div>


      <div class="notiz" *ngIf="m.pruefergebnisBemerkung">

        <span class="label">
          Bemerkung
        </span>

        <p>
          {{ m.pruefergebnisBemerkung }}
        </p>

      </div>

    </section>


    <!-- ===================================================
         PRÜFPUNKTE
         =================================================== -->
    <section class="karte">

      <h2>
        Prüfpunkte
      </h2>


      <p class="leer" *ngIf="pruefpunktGruppen.length === 0">

        Keine Prüfpunkte vorhanden.

      </p>


      <div class="pruefgruppe" *ngFor="let gruppe of pruefpunktGruppen">

        <h3>
          {{ gruppe.name }}
        </h3>


        <div class="pruefpunkt" *ngFor="let punkt of gruppe.punkte">

          <div class="pruefpunkt-kopf">

            <span class="pruefpunkt-name">
              {{ punkt.bezeichnung }}
            </span>

            <span class="ergebnis" [class.ok]="punkt.ergebnis === 1" [class.fehler]="punkt.ergebnis === 2"
              [class.irrelevant]="punkt.ergebnis === 3">

              {{ pruefpunktText(punkt.ergebnis) }}

            </span>

          </div>


          <p class="punkt-bemerkung" *ngIf="punkt.bemerkung">

            {{ punkt.bemerkung }}

          </p>

        </div>

      </div>

    </section>


    <!-- ===================================================
         BILDER
         =================================================== -->
    <section class="karte" *ngIf="m.bilder.length > 0">

      <h2>
        Bilder
      </h2>

      <div class="bilder-grid">

        <figure class="bild" *ngFor="let bild of m.bilder">

          <a [href]="bildUrl(bild.id)" target="_blank" rel="noopener">

            <img [src]="bildUrl(bild.id)" [alt]="bild.beschreibung || bild.fileName || 'Messstellenbild'"
              loading="lazy">

          </a>

          <figcaption>

            <span *ngIf="bild.beschreibung">
              {{ bild.beschreibung }}
            </span>

            <small>
              {{ bild.uploadedAtUtc | date:'dd.MM.yyyy HH:mm' }}
            </small>

          </figcaption>

        </figure>

      </div>

    </section>


    <!-- ===================================================
         VERLAUF
         =================================================== -->
    <section class="karte" *ngIf="m.pruefprotokoll.length > 0">

      <h2>
        Verlauf
      </h2>

      <div class="verlauf" *ngFor="let eintrag of m.pruefprotokoll">

        <div class="verlauf-kopf">

          <strong>
            {{ eintrag.beschreibung || eintrag.feldName || 'Änderung' }}
          </strong>

          <time>
            {{ eintrag.zeitpunktUtc | date:'dd.MM.yyyy HH:mm' }}
          </time>

        </div>


        <p *ngIf="eintrag.vorherigesErgebnisText || eintrag.ergebnisText">

          <span *ngIf="eintrag.vorherigesErgebnisText">
            {{ eintrag.vorherigesErgebnisText }}
            →
          </span>

          {{ eintrag.ergebnisText }}

        </p>


        <p *ngIf="eintrag.altWert != null || eintrag.neuWert != null">

          <span *ngIf="eintrag.altWert">
            {{ eintrag.altWert }}
            →
          </span>

          {{ eintrag.neuWert || '–' }}

        </p>


        <p class="punkt-bemerkung" *ngIf="eintrag.bemerkung">

          {{ eintrag.bemerkung }}

        </p>

      </div>

    </section>


    <footer class="footer">

      <span>
        Öffentlicher Nur-Lese-Zugang
      </span>

      <span *ngIf="m.updatedAtUtc">
        Stand:
        {{ m.updatedAtUtc | date:'dd.MM.yyyy HH:mm' }}
      </span>

    </footer>

  </ng-container>

</div>